import request from './request.js';
import COVERAPP from '../assets/js/COVERAPP.js';

let that = '';
const url = 'https://marketing.chuanbaoguancha.cn/v1/auth/cbgc';
var customUserAgent = 'Mozilla/5.0 (Linux; Android 10; ALP-AL00 Build/HUAWEIALP-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/79.0.3945.116 Mobile Safari/537.36 TheCover/7.0.0 (TheCover_7.0.0_android_ffffffff-c3df-abb4-ffff-ffffefeffe6f-AFGS)';

class Authorization{
  constructor(cacheName){
    that = this;
    that.cacheName = cacheName;
  }
  Auth(params){
    let type = params && params.type || '';
    let refresh = params && params.refresh || '';
    let authData = localStorage.getItem(that.cacheName);
    return new Promise((resolve, reject) => {
      if(refresh || !authData){
        that.httpAuth(type).then(res=>{
          resolve(res);
        }).catch(err=>reject(err));
      }else{
        authData = JSON.parse(authData);
        if(type == 'user'){ resolve(authData); return;}
        // let expires_in = type == 'token' ? authData.expires_in : authData.meta.custom.expires_in;
        let expires_in = authData.expires_in;
        let isExpired = expires_in - Date.now() < 400;
        if(isExpired){
          // 已经过期
          that.httpAuth().then(res=>{  
            resolve(res); 
          }).catch(err =>reject(err));
        }else{
          console.log('start COVERAPP GetUser2', authData);
          if(!COVERAPP.Attribute.isApp()){
            COVERAPP.Method.GetUser({
              callback: function(cguser){
                console.log('COVERAPP GetUser res2:', cguser);
                cguser = JSON.parse(cguser);
                if(authData.user.nickname !== cguser.nickname){
                  authData.user.nickname = cguser.nickname;
                  authData.user.name = cguser.nickname;
                  authData.user.avatar = cguser.avatar || 'https://h5.chuanbaoguancha.cn/cbgc-miniprogram/static/images/cg7.0/cg-avatar.png';
                  authData.user.mobile = cguser.mobile;
                  localStorage.setItem(that.cacheName, JSON.stringify(authData));
                }
                resolve(authData);
              }
            });
          }else{
            resolve(authData);
          }
        }
      }
    });
  }
  httpAuth(type){
    return new Promise((resolve, reject) => {
      let tempData;
      function handleData(tempData){
        let cacheData = '';
        switch(type){
          case 'user':
            cacheData = tempData.user;
          break;
          case 'token':
            cacheData = {
              expires_in: tempData.expires_in,
              access_token: tempData.access_token
            }
          break;
          default:
            cacheData = tempData;
          break;
        }
        localStorage.setItem(that.cacheName, JSON.stringify(cacheData));
        console.log('cacheData:', cacheData);
        resolve(cacheData);
      }
      request({
        url,
        method: 'POST'
      }).then(res=>{
        console.log('授权 res:', res,res.status, res.response && res.response.data.status);
        if(res.status!=200 || res.response&&res.response.data.status == 'error'){//!res.data && 
          // Object.defineProperty(navigator, 'userAgent',{
          //   value: customUserAgent,
          //   writable: false
          // });
          // console.log('ua:', navigator.userAgent);
          // var tempTimer = setTimeout(function(){
          //   that.httpAuth();
          //   clearTimeout(tempTimer);
          // }, 1000);
          reject(res);
        }else{
          console.log('start COVERAPP GetUser', res,COVERAPP.Attribute.isApp() );
          if(!COVERAPP.Attribute.isApp()){
            COVERAPP.Method.GetUser({
              origin: '',
              callback: function(cguser){
                cguser = JSON.parse(cguser);
                console.log('COVERAPP GetUser res:', cguser);
                res = res.data;
                tempData = {
                  user: {
                      id: res.data.id, 
                      idcard: res.data.idcard,
                      nickname: cguser.nickname || res.data.nickname,
                      avatar: cguser.avatar || res.data.avatar,
                      mobile: cguser.mobile || res.data.mobile,
                      name: cguser.nickname || res.data.name
                  },
                  access_token: res.meta.custom.access_token,
                  expires_in: Date.now() + res.meta.custom.expires_in*1000
                };
                // tempData.meta.custom.expires_in = Date.now() + tempData.meta.custom.expires_in*1000;
                handleData(tempData);
              }
            });
          }else{
            tempData = {
              user: res.data.data,
              access_token: res.data.meta.custom.access_token,
              expires_in: Date.now() + res.data.meta.custom.expires_in*1000
            }
            handleData(tempData);
          }
          
        }
        
      }).catch(err=>{
        console.log('授权失败 err:', err);
        Object.defineProperty(navigator, 'userAgent',{
          value: customUserAgent,
          writable: false
        });
        // that.httpAuth();
        reject(err);
      });
    });
  }
}




export default Authorization;